/* global currentCustomerId currentCustomerEmail */

$(document).ready(() => {
  const $form = $(document).find('[data-cms-form]');
  const $customerNumberField = $form.find('#id_kunden_nr');
  const $emailField = $form.find('#id_email');
  if ($form.length && currentCustomerId && $form.find('#id_objekt_name').length && $customerNumberField.length) {
    $customerNumberField.closest('label').hide();
    $customerNumberField.val(currentCustomerId);
    $emailField.val(currentCustomerEmail);
  }
});
